<p-dialog
  [closeOnEscape]="false"
  [modal]="true"
  [showHeader]="false"
  [style]="{ width: '320px', 'border-radius': '8px' }"
  [(visible)]="isIdleVisible"
>
  <div class="test">
    <div class="dialog-header"></div>

    <div class="signOutIconContainer">
      <fa-icon class="signOutIcon" [icon]="faSignOut"></fa-icon>
    </div>

    <div class="messagesContainer">
      <div class="message">Still there?</div>
      <div class="message">Your session will expire in:</div>
    </div>

    <div class="timeContainer">
      <div class="timeMessage">{{time}} seconds</div>
    </div>

    <div>
      <cre-button
        label="SIGN OUT"
        (onClick)="logout()"
        type="secondary"
      ></cre-button>
      <cre-button
        class="margin-left"
        label="STAY SIGNED IN"
        (onClick)="refreshSession()"
        type="primary"
      ></cre-button>
    </div>
</div>
</p-dialog>
